import type { ResponseData } from '../model/types';

type Props = {
    chartPoints: ResponseData;
};

type ReturnType = {
    max: number;
    min: number;
};

export const getMinMaxValue = ({ chartPoints }: Props): ReturnType => {
    if (!chartPoints.length) {
        return { min: 0, max: 0 };
    }

    let min = chartPoints[0].quote;
    let max = chartPoints[0].quote;

    for (const point of chartPoints) {
        if (point.quote < min) {
            min = point.quote;
        }
        if (point.quote > max) {
            max = point.quote;
        }
    }

    return { min: min - 100, max: max + 100 };
};
